<template>
  <section class="exhibition">
    <div class="section">
      <div class="container">
        <div class="item">
          <div class="service-details">
            <h3 class="item-title">电力监控系统</h3>
            <p class="text">
              电力监控系统包含电力设备管理、数据采集、远程控制、入侵报警、视频管理、事件报警、能源分析等功能。
            </p>
          </div>
          <div class="service-show-image">
            <img class="img" src="@/assets/img/show_pic1.png">
          </div>
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
export default {
  name: 'ServiceDetails',
}
</script>

<style lang="scss" scoped>
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.exhibition {
  margin: 0 auto;
}

.title {
  width: 100%;
  padding: 140px 0 130px;
  margin-top: 65px;
  background: url('../../assets/img/banner-bg1.jpg') center no-repeat;

  .content {
    font-size: 24px;
    font-weight: 700;
    color: #0e314c;
  }
}

.section {
  padding-top: 80px;

  @media (max-width: 745px) {
    padding: 50px 0;
  }
}

.container {
  @media (max-width: 575px) {
    .item{
      flex-flow: column;

      .service-details{
        .item-title{
          text-align: center;
        }
        .text{
          text-indent: 25px;
        }
      }
      
      .service-show-image{
        width: auto!important;
      }
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }

  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
  box-sizing: border-box;

  .item {
    display: flex;
    box-sizing: border-box;
    justify-content: center;

    .service-details {
      display: flex;
      flex: 1;
      flex-flow: column wrap;
      justify-content: center;
      text-align: left;
      padding: 0 15px;

      .item-title {
        color: #0e314c;
        font-size: 18px;
        margin: 0 0 15px;
      }

      .text {
        font-size: 14px;
        color: #6084a4;
        line-height: 1.9;
      }
    }

    .service-show-image{
      display: flex;
      width: 50%;
      padding: 0 15px;
      .img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }

  // @media (min-width: 975px) {
  //   max-width: 770px;
  // }

  // @media (min-width: 1156px) {
  //   max-width: 960px;
  // }
}
</style>